import { SelectOption } from './types'

export const getSelectedItem = <T>(
  valueToFind: T,
  options: SelectOption<T>[]
) => options.find(({ value }) => value === valueToFind)
